<template>
  <div class="paper">
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li>
          <a
            href="javascript:void(0)"
            aria-label="First"
            @click="current > 1  && goto(1)"
          >
            <span aria-hidden="true">&lt;&lt;</span>
          </a>
        </li>
        <li>
          <a
            href="javascript:void(0)"
            aria-label="Previous"
            @click="current > 1 && current-- && jumpcurrent-- && goto(current)"
          >
            <span aria-hidden="true">&lt;</span>
          </a>
        </li>
        <li :class="{ active: current == index }" v-for="index in pages">
          <a href="#" @click="goto(index)">{{ index }}</a>
        </li>
        <li>
          <a
            href="javascript:void(0)"
            aria-label="Next"
            @click="current < total && current ++ && jumpcurrent++ && goto(current)"
          >
            <span aria-hidden="true">&gt;</span>
          </a>
        </li>
        <li>
          <a
            href="javascript:void(0)"
            aria-label="Last"
            @click="current != total && end()"
          >
            <span aria-hidden="true">&gt;&gt;</span>
          </a>
        </li>
      </ul>
    </nav>
    <div style="margin-top:10px;">
          <input class="jumpPage" type="text" v-model="jumpcurrent" /> / {{total}}
          <a
            href="javascript:void(0)"
            style="
              margin-left: 10px;
              background: #337AB7;
              color: #fff;
              line-height:26px;
              height:26px;
              padding:0 10px;
              border-color: #337AB7;
              display:inline-block;
              border-radius:4px;
            "
            @click="goto(jumpcurrent)"
            >跳转</a>
         
    </div>
    <div style="margin-top:10px;">
        <span class="pageInfo">共有{{ allPage }}条纪录 每页20条纪录</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "paper",
  props: ["total", "allPage"],
  data() {
    return {
      jumpcurrent: 1, //跳转页计数
      current: 1, //显示页计数
      currentnum: 5, //导航总显示个数
    };
  },
  watch: {
    current: function (old, newVal) {},
  },
  computed: {
    pages: function () {
      var pag = [];
      if (this.current < this.currentnum) {
        //如果当前的激活的项 小于要显示的条数
        //总页数和要显示的条数那个大就显示多少条
        var i = Math.min(this.currentnum, this.total);
        while (i) {
          pag.unshift(i--);
        }
      } else {
        //当前页数大于显示页数了
        var middle = this.current - Math.floor(this.currentnum / 2), //从哪里开始
          i = this.currentnum;
        if (middle > this.total - this.currentnum) {
          middle = this.total - this.currentnum + 1;
        }
        while (i--) {
          pag.push(middle++);
        }
      }
      return pag;
    },
  },
  methods: {
    goto: function (index) {
      if (this.jumpcurrent > this.total) {
        this.jumpcurrent = this.current;
        swal({
          title: "超出最大页码",
          text: "2秒后自动关闭。",
          icon: "error",
          timer: 2000,
          buttons: false,
        });
        return;
      } else {
        this.jumpcurrent = index;
        this.current = index;
      }
      this.$emit("change", index);
    },
    first:function(){

    },
    end:function(){
      current = this.allPage;
      jumpcurrent = this.allPage;
      goto(this.allPage)
    }
  },
};
</script>

<style scoped>
.pagination {
  margin: 0;
}
.pagination > li > a, .jumpPage {
  background: none;
  /*background:rgba(211,220,230,.5);*/
  color: #333;
  padding: 0 2px;
  height: 26px;
  min-width: 22px;
  line-height: 26px;
  border:1px solid #ccc;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  font-size: 15px;
  text-align: center;
  display: inline-block;
}
.pagination li {
  display: inline-block;
}
/*.active {
background-color: #337AB7;
color:#fff;
}*/
.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: #337ab7;
  color: #f8f8f8;
  border-color: #337ab7;
}
.jumpPage {
  width: 25px;
  text-align: center;
}
.pageInfo {
  padding: 2px 10px;
  background: none;
  border: none;
  color: #444;
}
.pageInfo:hover {
  background: none;
  border: none;
  color: #444;
}
</style>


// WEBPACK FOOTER //
// src/components/Pager.vue